import {
  defineComponent, h, createApp,
  nextTick,
} from 'vue';
import store from '@/store';
import * as turf from '@turf/turf';

import { getEventIcon } from '@/utils/js/marker-icon';
import { antPath } from '@/utils/js/leaflet-plug/leaflet-ant-path-master/src/plugin/main.js'

import SvgIcon from '@/components/SvgIcon';
import LeafletConstructor from '@/components/LeafletConstructor';
import elementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn';
import { ElImage, } from 'element-plus';

const polygonStyle = store.getters['leafletRec/polygonStyle'],
      recStyle = store.getters['leafletRec/getConfig'];
      
import { getEventAllDetail } from '@/api/UserDrawApi';

const customMarkerTypeProp = store.getters['leafletPolygon/customMarkerTypeProp'],
      customTextProp = store.getters['leafletPolygon/customTextProp'],
      customTextColorProp = store.getters['leafletPolygon/customTextColorProp'];

export const getLeafletViewModeGroup = (list)=>{
  if(!list)return;
  if(!(list instanceof Array))return;
  const layerGroup = L.featureGroup();
  list.forEach((item)=>{
    const geoStr = JSON.parse(item['geom']),
          properties = geoStr['properties'];
    let layer;
    const geojson = L.geoJSON(geoStr).eachLayer(e=>{
      e['options']['dataItem'] = item;
      layer = e;
    });
    const isText = layer['feature']['properties'][customMarkerTypeProp] == customTextProp;
    if(isText){
      const textViewCom = getTextCom(item, properties),
            textViewApp = createApp(textViewCom),
            textViewDiv = document.createElement('div');
      textViewApp.mount(textViewDiv);
      layer.setIcon(
        L.divIcon({
          html: textViewDiv,
          className: 'text-edit-container',
        })
      );
    }
    
    layer.addTo(layerGroup);
    getOtherLayer(item, layer).addTo(layerGroup);
  })

  return layerGroup;
}

const getOtherLayer = (item, layer)=>{
  const dataLayerGroup = L.featureGroup();
  if(item['relatedInformation']){
    const otherList = JSON.parse(item['relatedInformation'])
    let text;
    if(otherList.length > 0){
      text = '<p style="text-align: center;">'+item['name']+'</p>';
      let clickText = '';
      for(let other of otherList){
        text+=`<p>${ other['type'] }: ${ other['refer'] }</p>`;
        clickText+=`${clickText!=''?'\n':''}${ other['type'] }: ${ other['refer'] }`;
      }
      layer.on({
        click: click=>{
          L.DomEvent.stop(click);
          if(navigator && navigator.clipboard && navigator.clipboard.writeText){
            navigator && navigator.clipboard.writeText(clickText);
          }else{
            const save = function(e) {
              e.clipboardData.setData('text/plain', clickText)
              e.preventDefault() // 阻止默认行为
            }
            document.addEventListener('copy', save) // 添加一个copy事件
            document.execCommand('copy') // 执行copy方法
          }
        }
      })
    }
  }
  if(item['relatedPosition']){
    const relatedPositionList = JSON.parse(item['relatedPosition']);
    const eventList = relatedPositionList.filter(e=> e['webDataType'] == 'event' );
    const osmList = relatedPositionList.filter(e=> e['webDataType'] == 'osm' );
    if(eventList.length > 0){
      eventList.forEach(event=>{
        const eventIcon = getEventIcon(event['typeName']);
        let loadingFlag = false,
            loadingFlagChange = ()=>{
              loadingFlag = !loadingFlag;
              if(loadingFlag){
                const loadingDom = document.createElement('div');
                loadingHtmlApp().mount(loadingDom);
                marker.setIcon(
                  L.divIcon({
                    html: loadingDom,
                  })
                );
              }else{
                marker.setIcon(eventIcon);
              }
            }
        const marker = L.marker(event, {
          icon: eventIcon,
        }).on({
          mouseover: mouseover => {
            textIcon['options']['className'] = textIconDefaultClass + ' leafle-view-mode-text-hover';
            textMarker.setIcon(textIcon);
          },
          mouseout: mouseout => {
            textIcon['options']['className'] = textIconDefaultClass;
            textMarker.setIcon(textIcon);
          },
          click: click => {
            if(loadingFlag)return;
            loadingFlagChange();
            eventMarkerClick(click, event, dataLayerGroup, loadingFlagChange);
          }
        }).addTo(dataLayerGroup);
        // .bindPopup(`<p>${ event['eventName'] }</p>`, {
        //   offset: [ 0, -10 ],
        //   closeButton: false,
        //   autoClose: false,
        //   direction: 'top',
        //   className: "leaflet-popup-message",
        // })

        const textIconDefaultClass = 'leafle-view-mode-text';
        const textIcon = L.divIcon({
          html: `<p>${ event['eventName'] }</p>`,
          className: textIconDefaultClass,
        })
        const textMarker = L.marker(event, {
          icon: textIcon,
          draggable: true,
        }).addTo(dataLayerGroup);
      })
    }
    if(osmList.length > 0){
      osmList.forEach(item=>{
        let bindText = '';
        const properties = item['geojson']['properties'];
        // for(const key in properties){
        if(properties['name']){
          bindText+=`<p>${properties['name']}</p>`
        }
        let textMarker;
        const geojson = L.geoJSON(item['geojson'], {
          onEachFeature: (feature, layer)=>{
            // layer.setStyle({
            //   color: osmDefaultColor,
            // })
          },
        }).on({
          mouseover: mouseover => {
            if(!textMarker)return;
            textIcon['options']['className'] = textIconDefaultClass + ' leafle-view-mode-text-hover';
            textMarker.setIcon(textIcon);
          },
          mouseout: mouseout => {
            if(!textMarker)return;
            textIcon['options']['className'] = textIconDefaultClass;
            textMarker.setIcon(textIcon);
          },
          click: click => {
            if(!textMarker)return;
            if(dataLayerGroup.hasLayer(textMarker)){
              dataLayerGroup.removeLayer(textMarker);
            }else{
              dataLayerGroup.addLayer(textMarker);
            }
          }
        }).addTo(dataLayerGroup);
        if(bindText == '')return;
        const textIconDefaultClass = 'leafle-view-mode-text';
        const textIcon = L.divIcon({
          html: `<p>${ bindText }</p>`,
          className: textIconDefaultClass,
        })
        const center = turf.center(geojson.toGeoJSON());
        textMarker = L.marker(center['geometry']['coordinates'].reverse(), {
          icon: textIcon,
          draggable: true,
        }).addTo(dataLayerGroup);
      })
    }
  }
  return dataLayerGroup;
}

const loadingHtmlApp = ()=>{
  return createApp(
    defineComponent({
      setup(){
        return ()=> h(SvgIcon, {
          iconName: 'loading',
        })
      },
    })
  )
}

const eventMarkerClick = (event, item, layerGroup, callback)=>{
  const marker = event.target;
  const eventInfoInit = (res)=>{
    const data = JSON.parse(res);
    // console.log(data);
    const contentDom = document.createElement('div');
    let app;
    if(item['typeName'] == '政要出访' || item['typeName'] == '侦察预警'){
      app = defineComponent({
        setup(){
          return ()=> h(LeafletConstructor, {
            isAddBaseLayer: true,
            isDragging: false,
            zoomShow: false,
            isShowInfoControl: false,
            onMapInit: (map)=>{
              // console.log(map);
              const track = data['track'],
                    trackList = track && track['trackArr'];
              if(!trackList)return;
              const path = L.polyline.antPath(
                trackList
              , {
                color: '#FF0000',
                pulseColor: '#FFFFFF',
                delay: 400,
                weight: 3,
                dashArray: [10, 20]
              }).addTo(map);
              path.getBounds().isValid() && map.fitBounds(path.getBounds(), 15);
            },
          })
        }
      })
    }else{
      app = defineComponent({
        setup(){
          return ()=> h(ElImage, {
            fit: 'contain',
            src: data['imagePath'],
            previewSrcList: [data['imagePath']],
            previewTeleported: true,
            lazy: true,
          }, {
            placeholder: ()=> h('img', {
              src: data['imagePath'],
            }),
          })
        }
      })
    }
    let createContent;
    const contentMarker = L.marker(marker.getLatLng(), {
      icon: L.divIcon({
        className: 'leaflet-view-mode-event-content',
      }),
      draggable: true,
    }).on({
      add: add=>{
        if(createContent){
          contentMarker._icon && createContent.unmount(contentMarker._icon);
        }
        createContent = createApp(app);
        createContent.use(elementPlus, {
          locale: zhCn,
        });
        contentMarker._icon && createContent.mount(contentMarker._icon);
      }
    })
    contentMarker.addTo(layerGroup);
  }
  if(item['eventResData']){
    callback && callback();
    return;
  }
  getEventAllDetail(item).then(res=>{
    if(res.data.code == 1004){
      item['eventResData'] = res.data.data;
      eventInfoInit(res.data.data)
    }
    callback && callback();
  }).catch(err=>{
    callback && callback();
    console.log(err);
  });
}

const getTextCom = (target, properties)=>{
  // console.log(target);
  return defineComponent({
    setup(){
      return ()=> h('div', {
          class: 'text-edit-inner-container',
        },
        h('div', {
          class: 'text-edit-inner',
          style: {
            color: properties[customTextColorProp] || 'var(--fontColor_13)',
            borderColor: properties[customTextColorProp] || 'var(--fontColor_13)',
            'word-wrap': 'break-word',
          }
        }, properties[customTextProp])
      )
    },
  });
}